import PathAnimation from './top-kv/path-animation.js';
import KvDraw from './top-kv/kv-draw.js';
import PathLoop from './top-kv/path-loop.js';
import KvTxtImg from './top-kv/kv-txt-img.js';
import BottomCircle from './top-kv/bottom-circle.js';

export default class TopKv {
  constructor() {
    this.pathGroupSelectors = ['.js-kv1', '.js-kv2', '.js-kv3', '.js-kv4'];
    this.kvPaths = document.querySelectorAll(this.pathGroupSelectors.join(','));

    this.pathAnimation = new PathAnimation({
      reverseClass: 'js-kv_reverse',
      pathColorEasing: 'ease-in-out'
    });

    this.kvTxtImg = new KvTxtImg({
      txtImgPcBoxSelectors: [
        '.p-index__kv_txt_img_box--last',
        '.p-index__kv_txt_img_box--first',
        '.p-index__kv_txt_img_box--second',
        '.p-index__kv_txt_img_box--third',
        '.p-index__kv_txt_img_box--fourth'
      ]
    });

    this.kvDraw = new KvDraw({
      pathAnimation: this.pathAnimation,
      pathGroupSelectors: this.pathGroupSelectors,
      onKv3Complete: () => this.kvTxtImg.showAll(),
      onAllComplete: (totalDelay) => this.pathLoop.schedule(totalDelay)
    });

    this.pathLoop = new PathLoop({
      pathAnimation: this.pathAnimation,
      kvArcSvgSelectors: ['.p-index__kv_svg_arc_pc svg', '.p-index__kv_svg_arc_sp svg'],
      onColorStep: () => this.kvTxtImg.cycle(),
      onPause: () => this.kvTxtImg.clearCycleTimer()
    });

    // KV下の丸いアニメーション
    this.bottomCircle = new BottomCircle();

    if (this.kvPaths.length > 0) {
      this.initKv();
    }

    this.bottomCircle.init();
  }

  initKv() {
    this.kvDraw.prepare();
    this.kvTxtImg.init();
    this.kvDraw.start();
  }
}
